'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.getIsActive = undefined;
exports.doCreateHistory = doCreateHistory;
exports.createOnClick = createOnClick;
exports.mapDispatchToProps = mapDispatchToProps;

var _fp = require('lodash/fp');

var _reselect = require('reselect');

var _locationInfo = require('location-info');

var _reduxHistorySync = require('redux-history-sync');

var _capeRouter = require('cape-router');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// import { getLocation } from './util'

var getIsActive = exports.getIsActive = (0, _fp.overArgs)(_fp.eq, [_capeRouter.getRouteId, (0, _fp.get)('routeId')]);

var mapStateToProps = exports.mapStateToProps = (0, _reselect.createStructuredSelector)({
  href: _locationInfo.getHref,
  isActive: getIsActive,
  isInternal: _fp.stubTrue
});
function doCreateHistory(props) {
  return function (dispatch, getState) {
    return dispatch((0, _reduxHistorySync.createHistory)((0, _locationInfo.getHref)(getState(), props)));
  };
}
function createOnClick(dispatch, ownProps) {
  return function (event) {
    event.preventDefault();

    var onClick = ownProps.onClick,
        props = _objectWithoutProperties(ownProps, ['onClick']);

    if ((0, _fp.isFunction)(onClick)) onClick(ownProps);
    return dispatch(doCreateHistory(props));
  };
}
// @TODO Enable link to optionally call HISTORY_RESTORE action.
function mapDispatchToProps(dispatch, ownProps) {
  return {
    onClick: createOnClick(dispatch, ownProps)
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-history-component/lib/container.js
// module id = 1271
// module chunks = 0